export default {
  ADMIN_URL: process.env.REACT_APP_ADMIN_URL,
  WIDGET_ENDPOINT: process.env.REACT_APP_WIDGET_ENDPOINT,
  PLATFORM_ENDPOINT: process.env.REACT_APP_PLATFORM_ENDPOINT,
  SERVER_ENDPOINT: process.env.REACT_APP_SERVER_ENDPOINT,
};
